// extracted by mini-css-extract-plugin
export default {"container":"view__container___FzJJV","containerModal":"view__containerModal___ajWZl"};